module.exports = __webpack_public_path__ + "img/AGOSTINHO.62f754ee.png";